"use strict";

var Shopify = Shopify || {};
window.onVariantChangeCallback = function (instance, productUrl) {
  return html => {
    const sectionId = instance.sectionId;
    const variant = instance.getSelectedVariant(html);
    if (variant) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", variant.id);
      window.history.replaceState({}, '', newUrl.toString());
    }
    const pickUpAvailability = document.querySelector('pickup-availability');
    const shareButton = document.getElementById(`Share-${sectionId}`);
    const priceWrapper = document.querySelector(`#price-${sectionId}`);
    const priceWrapperDest = html.querySelector(`#price-${sectionId}`);
    const taxWrapper = document.querySelector(`#ProductInfo-${sectionId} .product__tax`);
    const taxWrapperDest = html.querySelector(`#ProductInfo-${sectionId} .product__tax`);
    const addToCartBtn = document.querySelector(`#shopify-section-${sectionId} .js-btn-add-to-cart`);
    const productMediaThumb = document.querySelector(`#shopify-section-${sectionId} [data-thumbs-media="${variant?.featured_media?.id || "undefined-variant"}"]`);
    const productOptions = document.querySelector(`#shopify-section-${sectionId} product-options`);
    const productOptionsDest = html.querySelector(`#shopify-section-${sectionId} product-options`);
    const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`);
    if (productMediaThumb) {
      setTimeout(function () {
        productMediaThumb.click();
      }, 25);
    }
    if (priceWrapper && priceWrapperDest) {
      if (priceWrapperDest.dataset?.exists === "null") {
        priceWrapper.classList.add('visually-hidden');
        taxWrapper && taxWrapper.classList.add("visually-hidden");
      } else {
        priceWrapper.outerHTML = priceWrapperDest.outerHTML;
        if (taxWrapper && taxWrapperDest) {
          taxWrapper.outerHTML = taxWrapperDest.outerHTML;
        } else if (taxWrapper) {
          taxWrapper.classList.add("visually-hidden");
        }
      }
    }
    if (addToCartBtn) {
      addToCartBtn.disabled = !(variant && variant?.available);
      addToCartBtn.querySelector("span").innerHTML = variant ? variant?.available ? addToCartBtn.dataset.msgAvailable : addToCartBtn.dataset.msgSoldout : addToCartBtn.dataset.msgUnavailable;
    }
    if (shareButton && variant) {
      shareButton.updateUrl(`${window.shopUrl}${productUrl}?variant=${variant.id}`);
    }
    if (pickUpAvailability) {
      if (variant && variant?.available) {
        pickUpAvailability.fetchAvailability(variant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
    if (productOptions && productOptionsDest) {
      productOptions.innerHTML = productOptionsDest.innerHTML;
      productOptions.initOptions();
      productOptions.updateOptions();
    }
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && variant) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    });
    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId,
        html: "",
        variant
      }
    });
  };
};
window.ProductOption = class ProductOption extends HTMLElement {
  constructor() {
    super();
    this.inputEl = this.querySelector('input[data-input]');
    this.labelEl = this.querySelector('label[data-label]');
    this.optionsRootEl = this.closest('product-options');
  }
  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.optionsRootEl.uncheckAllOptions(this.depth);
    this.dataset.checked = true;
    this.optionsRootEl.updateOptions();
    this.optionsRootEl.callOnchangeCallback(event.target);
  }
  connectedCallback() {
    this.depth = +this.dataset.depth;
    this.inputEl.style.userSelect = "none";
    this.inputEl.style.pointerEvents = "none";
    this.addEventListener('click', this.handleClick);
  }
  static observedAttributes = ['data-checked'];
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "data-checked":
        if (newValue === "true") {
          this.inputEl.checked = true;
        } else {
          this.inputEl.removeAttribute('checked');
        }
        break;
      default:
        break;
    }
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
};
window.ProductOptions = class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }
  initOptions() {
    this.optionEls = [];
    for (let i = 0; i < this.maxDepth + 1; i++) {
      this.optionEls[i] = Array.from(this.querySelectorAll(`product-option[data-depth="${i}"],product-option-select[data-depth="${i}"]`));
    }
    let colorNameKeys = Object.keys(window.murmel.theme_settings).filter(x => x.startsWith('color_name_x'));
    let colorPalette = {};
    window.murmel.color_palette.forEach(pair => {
      colorPalette[pair[0]] = "#" + pair[1];
    });
    colorNameKeys.forEach(colorNameKey => {
      let colorValueKey = colorNameKey.replace("name", "value");
      let colorName = window.murmel.theme_settings[colorNameKey].toLowerCase();
      let colorValue = window.murmel.theme_settings[colorValueKey];
      colorPalette[colorName] = colorValue;
    });
    Array.from(this.querySelectorAll(`product-option[data-color]`)).forEach(colorOption => {
      let searchValue = colorOption.dataset.value.trim().toLowerCase();
      let searchValueNoWhitespace = searchValue.replace(/\s/g, "");
      let foundColor = colorPalette[searchValue] || colorPalette[searchValueNoWhitespace] || searchValue;
      colorOption.style.setProperty("--color", foundColor);
    });
  }
  uncheckAllOptions(depth) {
    this.optionEls[depth].forEach(optionEl => {
      delete optionEl.dataset.checked;
    });
  }
  updateOptions() {
    this.options = [];
    this.optionsValues = [];
    this.optionsValueIds = [];
    for (let i = 0; i < this.maxDepth + 1; i++) {
      if (this.optionEls[i].length === 1 && this.optionEls[i][0].dataset.type === 'dropdown') {
        this.options[i] = this.optionEls[i][0];
        this.optionsValues[i] = this.options[i].dataset.value;
        this.optionsValueIds[i] = Number(this.options[i].dataset.optionValueId);
      } else {
        this.options[i] = this.optionEls[i].find(x => x.hasAttribute('data-checked'));
        this.optionsValues[i] = this.options[i].dataset.value;
        this.optionsValueIds[i] = Number(this.options[i].dataset.optionValueId);
      }
    }
  }
  callOnchangeCallback(target) {
    const addToCartBtn = document.querySelector(`#shopify-section-${this.sectionId} .js-btn-add-to-cart`);
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
    }
    const productUrl = this.pendingRequestUrl || this.dataset.url;
    this.pendingRequestUrl = productUrl;
    this.fetchProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, this.optionsValueIds),
      targetId: target?.id || undefined,
      callback: this.onchangeCallback(this, productUrl)
    });
  }
  buildRequestUrlWithParams(url, optionValues) {
    const params = [];
    params.push(`section_id=${this.sectionId}`);
    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }
    return `${url}?${params.join('&')}`;
  }
  fetchProductInfo(_ref) {
    let {
      requestUrl,
      targetId,
      callback
    } = _ref;
    this.abortController?.abort();
    this.abortController = new AbortController();
    fetch(requestUrl, {
      signal: this.abortController.signal
    }).then(response => response.text()).then(responseText => {
      this.pendingRequestUrl = null;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      callback(html);
    }).then(() => {
      if (targetId) {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      }
    }).catch(error => {
      if (error.name === 'AbortError') {
        console.log('Fetch aborted by user');
      } else {
        console.error(error);
      }
    });
  }
  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('product-options [data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }
  connectedCallback() {
    this.onchangeCallback = window[this.dataset.onchange];
    this.maxDepth = Number(this.dataset.maxDepth);
    this.options = [];
    this.optionsValues = [];
    this.optionsValueIds = [];
    this.pendingRequestUrl = null;
    this.abortController = undefined;
    this.initOptions();
    this.updateOptions();
    this.callOnchangeCallback();
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
  get sectionId() {
    return this.dataset.section;
  }
};
class ProductOptionSelect extends HTMLElement {
  constructor() {
    super();
    this.selectEl = this.querySelector('select[data-select]');
    this.optionsRootEl = this.closest('product-options');
  }
  handleChange(event) {
    event.preventDefault();
    event.stopPropagation();
    this.optionsRootEl.uncheckAllOptions(this.depth);
    this.dataset.value = this.selectEl.value;
    this.dataset.optionValueId = this.selectEl.selectedOptions?.[0]?.dataset?.optionValueId;
    this.optionsRootEl.updateOptions();
    this.optionsRootEl.callOnchangeCallback(event.target);
  }
  connectedCallback() {
    this.depth = Number(this.dataset.depth);
    this.addEventListener('change', this.handleChange);
  }
  static observedAttributes = ['data-value'];
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-value':
        this.selectEl.value = newValue;
        break;
      default:
        break;
    }
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }
}
if (!customElements.get("product-options")) customElements.define("product-options", ProductOptions);
if (!customElements.get("product-option")) customElements.define("product-option", ProductOption);
if (!customElements.get("product-option-select")) customElements.define("product-option-select", ProductOptionSelect);